(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('action-print-element', actionFunc);

    function actionFunc() {
        return function(options) {
            var ifr = document.createElement('iframe');
            ifr.find('head').append($("<link/>",
                { rel: "stylesheet", href: options.css_link, type: "text/css" }
            ));
            ifr.style='height: 0px; width: 0px; position: absolute';
            document.body.appendChild(ifr);
            ifr.find('body').addClass('rms-common');


            $(options.selector).clone().appendTo(ifr.contentDocument.body);
            ifr.contentWindow.print();

            ifr.parentElement.removeChild(ifr);
        };
    }
})();
